import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const issuePettyCashCheques = createAsyncThunk(
	"issuePettyCashCheques",
	async ({ requestIds, chequeReff, chequeDate, cheque_amount }, { rejectWithValue }) => {
		try {
			const response = await axiosHttp.post("petty-cash/cheque/issue", {
				requestIds,
				chequeReff,
				issued_at: chequeDate,
				cheque_amount,
			});
			return response.data;
		} catch (err) {
			if (!err.response) {
				throw err;
			}
			return rejectWithValue(err.response.data);
		}
	},
);

const PettyCashChequeIssueSlice = createSlice({
	name: "PettyCashChequeIssueSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},
	reducers: {
		resetPettyCashChequeIssueState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(issuePettyCashCheques.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
			state.error = null;
		});
		builder.addCase(issuePettyCashCheques.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});
		builder.addCase(issuePettyCashCheques.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetPettyCashChequeIssueState } = PettyCashChequeIssueSlice.actions;
export default PettyCashChequeIssueSlice.reducer;
